/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesretrying1Inputs */

const en_filesretrying1 = /** @type {(inputs: Filesretrying1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrying…`)
};

const pt_filesretrying1 = /** @type {(inputs: Filesretrying1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tentar…`)
};

/**
* | output |
* | --- |
* | "Retrying…" |
*
* @param {Filesretrying1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesretrying1 = /** @type {((inputs?: Filesretrying1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesretrying1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesretrying1(inputs)
	return pt_filesretrying1(inputs)
});
export { filesretrying1 as "filesRetrying" }